import React, { useMemo } from 'react';
import { Link, type LinkProps, useLocation } from 'react-router-dom';

import { buildEtfNavigationState } from '../config/navigation';

const SPECIAL_TICKER_ROUTES = new Map<string, string>([
  ['CPO1!', '/dashboards/commodities/cpo1'],
]);

type EtfTickerLinkProps = Omit<LinkProps, 'to' | 'state'> & {
  ticker: string;
  backLabel?: string;
};

const EtfTickerLink: React.FC<EtfTickerLinkProps> = ({
  ticker,
  backLabel,
  children,
  ...linkProps
}) => {
  const location = useLocation();
  const normalizedTicker = ticker.trim().toUpperCase();
  const specialRoute = SPECIAL_TICKER_ROUTES.get(normalizedTicker) || null;
  const navigationState = useMemo(
    () =>
      buildEtfNavigationState({
        pathname: location.pathname,
        search: location.search,
        label: backLabel,
      }),
    [backLabel, location.pathname, location.search]
  );

  return (
    <Link
      to={
        specialRoute || `/etf/${encodeURIComponent(normalizedTicker)}`
      }
      state={navigationState}
      {...linkProps}
    >
      {children ?? ticker}
    </Link>
  );
};

export default EtfTickerLink;
